import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";

import { PrimaryButton } from "../../../ui/Button/Button";
import { dealerOrderModalHash } from "./DealerOrderModal";

type OrderNowButtonProps = {
  className?: string;
};

export const OrderNowButton: FunctionComponent<OrderNowButtonProps> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Link to={dealerOrderModalHash}>
      <PrimaryButton
        aria-label="openOrderDialog"
        className={className}
        element="a"
      >
        {t("cart.orderNow")}
      </PrimaryButton>
    </Link>
  );
};
